import { render, staticRenderFns } from "./withData.vue?vue&type=template&id=f0b33ece"
import script from "./withData.vue?vue&type=script&lang=js"
export * from "./withData.vue?vue&type=script&lang=js"
import style0 from "./withData.vue?vue&type=style&index=0&id=f0b33ece&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports